import { Row, message } from "antd";
// import PropTypes from "prop-types";
import classes from "../Pages.module.css";
import {useContext ,useState} from "react";
import DataContext from "../../../Context/dataContext";
import DataField from "./DataField";
import axios from "axios";
import dayjs from "dayjs";


const BasicDetail = (props) => {
  const [addres, setAddres] = useState({});
  const [customers, setCustomers] = useState({});
  const employeeData = useContext(DataContext);
  console.log(props, "props in basic detail in inward job work");
  const handleChange = (e, param) => {
    props.setData((data) => {
      const newdata = [...data["prodHdr"]];
      newdata[0][param] = e.target.value;
      return {
        ...data,
        prodHdr: newdata,
      };
    });
  };

 console.log(props.ad.DISTRIBUTOR_CODE,"props data of distributor code");
  


  // const handleSChange = (val, param) => {
  //   console.log("value is this ", val," param is this " ,param);
  //   // console.log(val, "Truwwww");
  //   props.setData((data) => {
  //     const newdata = [...data["prodHdr"]];
  //     newdata[0][param] = val;
  //     return {
  //       ...data,
  //       prodHdr: newdata,
  //     };
  //   });
  // };
console.log(props.data.cust_code,"customer code is this ");
  const handleSChange = async (val, param) => {
    props.setData((data) => {
      const newdata = [...data["prodHdr"]];
      newdata[0][param] = val;
  
      // Clear customer selection if dealer changes
      if (param === "dealer_code") {
        newdata[0]["cust_code"] = "";
        newdata[0]["place_of_supply"] = "";// Reset customer field
      }
      if (param === "cust_code") {
        newdata[0]["place_of_supply"] = ""; // Reset customer field
      }
  
      return {
        ...data,
        prodHdr: newdata,
      };
    });
  
    if (param === "dealer_code") {
      setCustomers({}); // Clear previous customer options
      setAddres({});
      try {
        const response = await axios.get(
          employeeData.URL + `/api/v1/jobworkInward/fetchCustomers`,
          {
            withCredentials: true,
            params: { dealer_code: val },
          }
        );
  
        console.log(response, "response from customer API");
        setCustomers(response.data); // Update with new customer options
      } catch (error) {
        message.error("Failed to fetch customers. Please try again.");
      }
    }
    if(param === "cust_code"){
      setAddres(null);
      try{
        const response =  await axios
        .get(employeeData.URL + "/api/v1/jobworkInward/fetchAddress", {
          withCredentials: true,
          params: { cust_code: val },
        });
        console.log(response, "response from Address API");
        setAddres(response.data);
      }catch (error) {
        message.error("Failed to fetch Address. Please try again.");
      }
    }
    if(param === "out_job_no"){
      try{
        const response =  await axios
        .get(employeeData.URL + "/api/v1/jobworkInward/fetchOutwardDetails", {
          withCredentials: true,
          params: { outward_code: val },
        });
        const updatedData = {
          ...response.data,
          outward_code: val, // Add inward_code to the response data
        };
        props.updateOutwardDetails(updatedData);
        
      }catch (error) {
        message.error("Failed to fetch Address. Please try again.");
      }
    }
  };
  
  


  
  
  const handleDChange = (date, dateString, param) => {
    props.setData((data) => {
      const newdata = [...data["prodHdr"]];
      newdata[0][param] = dateString;
      return {
        ...data,
        prodHdr: newdata,
      };
    });
  };

  // const handleTChange = (time, timeString, param) => {
  //   props.setData((data) => {
  //     const newdata = [...data["reqHdr"]];
  //     // Assuming `timeString` is in the format "HH:mm:ss"
  //     newdata[0][param] = timeString;
  //     return {
  //       ...data,
  //       reqHdr: newdata,
  //     };
  //   });
  // };

  // const handleDTChange = (date, dateString, param) => {
  //   props.setData((data) => {
  //     const newdata = [...data["prodHdr"]];
  //     newdata[0][param] = dateString;

  //     // Calculate the total time if both from_req_time and to_req_time are filled
  //     const fromTime =
  //       param === "from_time" ? dateString : data.prodHdr[0].from_time;
  //     const toTime = param === "to_time" ? dateString : data.prodHdr[0].to_time;

  //     if (fromTime && toTime) {
  //       const from = dayjs(fromTime, "DD-MM-YYYY HH:mm:ss");
  //       const to = dayjs(toTime, "DD-MM-YYYY HH:mm:ss");

  //       if (to.isAfter(from)) {
  //         const diff = to.diff(from, "hour", true); // Calculate the difference in hours
  //         newdata[0]["no_of_hrs"] = diff.toFixed(2); // Update the total with the calculated difference
  //       } else {
  //         message.error("To Time should be after From Time");
  //         newdata[0]["no_of_hrs"] = "";
  //       }
  //     }

  //     return {
  //       ...data,
  //       prodHdr: newdata,
  //     };
  //   });
  // };
  return (
    <div>
      <p></p>
      <Row className={props.editMode ? classes["RowDEX"] : classes["RowD"]}>
        {!props.create && (
          <DataField
            editMode={props.editMode}
            lg={12}
            md={24}
            name="Requisition Code"
            param="REQ_CODE"
            value={props.data.req_code}
          />
        )}
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleSChange}
          options={props.vd}
          type="Select"
          name="Jobwork Type"
          id="packing_type"
          required="True"
          param="packing_type"
          value={props.data.packing_type}
        />
        {props.data.packing_type === "J" && (
          <DataField
            editMode={props.editMode}
            lg={4}
            md={24}
            id="type"
            options={props.ad.outward_code}
            handleChange={handleSChange}
            type="Select"
            required="True"
            name="Outward Code"
            param="out_job_no"
            value={props.data.out_job_no}
            //  onClick={handleReqCodeClick} // Add onClick handler here as well
            // value={props.data.req_code}
            rules={[{ message: "missing name" }]}
            // ref={reqtype}
            // onNextFocus={() => planDateRef.current.focus()}
            // disabled={props.editordMode1}
          />
        )}

  
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Challan No"
          id="chalan_no"
          required="True"
          param="chalan_no"
          value={props.data.chalan_no}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleDChange}
          type="Date"
          id="ppc_date"
          required="True"
          name="Challan Date"
          param="ppc_date"
          value={props.data.ppc_date}
          rules={[{ message: "missing name" }]}
        />
        
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Mode Of Transport"
          id="mode_of_trans"
          required="True"
          param="mode_of_trans"
          value={props.data.mode_of_trans}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleSChange}
          options={props.ad.EMPLOYEE}
          type="Select"
          name="Transporter Name"
          id="trans_account"
          required="True"
          param="trans_account"
          value={props.data.trans_account}
        />
          <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Gross Wt"
          id="gross_wt"
          required="True"
          param="gross_wt"
          value={props.data.gross_wt}
        />
          <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Tare Wt"
          id="tare_wt"
          required="True"
          param="tare_wt"
          value={props.data.tare_wt}
        />
          <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Net Wt"
          id="net_wt"
          required="True"
          param="net_wt"
          value={props.data.net_wt}
        />
          <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Gr No"
          id="grno"
          required="True"
          param="grno"
          value={props.data.grno}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleDChange}
          type="Date"
          id="gr_date"
          required="True"
          name="Gr Date"
          param="gr_date"
          value={props.data.gr_date}
          rules={[{ message: "missing name" }]}
        />
          <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleSChange}
          options={props.ad.ITEM_CATA}
          type="Select"
          name="Type Stock"
          required="True"
          id="type_stock"
          param="type_stock"
          value={props.data.type_stock}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleSChange}
          options={props.ad.DEALER_CODE}
          type="Select"
          name="Dealer Name"
          required="True"
          id="dealer_code"
          param="dealer_code"
          value={props.data.dealer_code}
        />

         <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleSChange}
          options={customers}
          type="Select"
          name="Customer Name"
          required="True"
          id="cust_code"
          param="cust_code"
          value={props.data.cust_code}
          customers={props.editMode1 ? props.customers : customers}
        />

         <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleSChange}
          // options={props.ad.DEL_ADD}
          options={addres}
          type="Select"
          name="Delivery Address"
          required="True"
          id="place_of_supply"
          param="place_of_supply"
          value={props.data.place_of_supply}
          addres={props.editMode1 ? props.addres : addres}
        />

         <DataField
          editMode={props.editMode}
          lg={8}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Remarks"
          id="remark"
          required="True"
          param="remark"
          value={props.data.remark}
        />
      </Row>
    </div>
  );
};

export default BasicDetail;
